import { jsxs as l, jsx as C } from "react/jsx-runtime";
function t(r) {
  return /* @__PURE__ */ l("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...r, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M2.01617 10.991C2.26646 8.46354 3.3377 6.32567 5.21994 4.5974C7.10219 2.86913 9.35489 2 11.978 2C13.3597 2 14.6612 2.25974 15.8727 2.78921C17.0841 3.31868 18.1453 4.02797 19.0564 4.93706C19.9675 5.84615 20.6884 6.90509 21.209 8.11389C21.7296 9.32268 22 10.6114 22 11.99C22 13.3686 21.7397 14.6573 21.209 15.8761C20.6784 17.0949 19.9675 18.1538 19.0564 19.0629C18.1453 19.972 17.0841 20.6913 15.8727 21.2108C14.6612 21.7303 13.3697 22 11.978 22C11.097 22 10.236 21.8901 9.39498 21.6703C8.55397 21.4506 7.76302 21.1309 7.01213 20.6913C6.71177 20.5215 6.54156 20.2817 6.51153 19.962C6.48149 19.6424 6.5916 19.3526 6.86192 19.0829C7.0121 18.9331 7.20228 18.8432 7.44257 18.8032C7.68286 18.7632 7.8831 18.8032 8.07333 18.9331C8.69407 19.2627 9.32485 19.5225 9.97563 19.7123C10.6264 19.9021 11.2972 19.992 11.978 19.992C14.2007 19.992 16.083 19.2128 17.6448 17.6543C19.2067 16.0959 19.9876 14.2078 19.9876 12C19.9876 9.79221 19.2067 7.9041 17.6448 6.34565C16.083 4.78721 14.1907 4.00799 11.978 4.00799C9.92557 4.00799 8.14348 4.67732 6.64169 6.01598C5.13989 7.35465 4.25884 9.01299 4.00854 11.001C3.9785 11.2807 3.85827 11.5205 3.66804 11.7103C3.47781 11.9001 3.23757 12 2.95723 12C2.6769 12 2.43665 11.9001 2.24642 11.7003C2.05619 11.5005 1.97611 11.2707 2.00614 11.001L2.01617 10.991Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M4.96958 16.7353C4.77936 16.7353 4.5891 16.6653 4.43892 16.5155C4.14857 16.2258 4.14857 15.7463 4.43892 15.4565L8.4437 11.4605C8.73405 11.1708 9.21468 11.1708 9.50503 11.4605C9.79538 11.7502 9.79538 12.2298 9.50503 12.5195L5.50025 16.5155C5.35007 16.6653 5.15981 16.7353 4.96958 16.7353Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M10.9768 14.7373C10.7865 14.7373 10.5963 14.6673 10.4461 14.5175L8.4437 12.5195C8.15336 12.2298 8.15336 11.7502 8.4437 11.4605C8.73405 11.1708 9.21468 11.1708 9.50503 11.4605L11.5074 13.4585C11.7978 13.7483 11.7978 14.2278 11.5074 14.5175C11.3572 14.6673 11.167 14.7373 10.9768 14.7373Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M10.9768 14.7373C10.7865 14.7373 10.5963 14.6673 10.4461 14.5175C10.1557 14.2278 10.1557 13.7483 10.4461 13.4585L15.4521 8.46354C15.7424 8.17383 16.2231 8.17383 16.5134 8.46354C16.8038 8.75325 16.8038 9.23277 16.5134 9.52248L11.5074 14.5175C11.3572 14.6673 11.167 14.7373 10.9768 14.7373Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C("path", { d: "M12.7289 8.99301H15.9828V11.99L12.7289 8.99301Z", fill: "currentColor" }),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M15.9828 12.7393C15.8025 12.7393 15.6123 12.6693 15.4721 12.5395L12.2183 9.54246C11.988 9.33267 11.918 9.003 12.0281 8.72328C12.1382 8.44356 12.4185 8.24376 12.7289 8.24376H15.9828C16.3933 8.24376 16.7337 8.58342 16.7337 8.99301V11.99C16.7337 12.2897 16.5535 12.5594 16.2832 12.6793C16.183 12.7193 16.0829 12.7393 15.9828 12.7393ZM14.6512 9.74226L15.2319 10.2817V9.74226H14.6512Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  t as default
};
